import {
  Grid,
  TextField,
  Autocomplete,
  Chip,
  Typography,
  Button,
} from "@mui/material";
import { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import { useRouter } from "next/router";

export const TextSearch = ({
  closeQuickSearchModal,
}: {
  closeQuickSearchModal: () => void;
}) => {
  const [input, setInput] = useState<string[]>([]);
  const router = useRouter();

  const handleClick = () => {
    const quickSearchId = uuidv4();
    const data = {
      searchTerms: input,
      searchType: "text",
      mediaCategory: null,
    };
    sessionStorage.setItem(quickSearchId, JSON.stringify(data));
    router.push({
      pathname: "/search",
      query: { searchId: quickSearchId, tr: "30d" },
    });
    closeQuickSearchModal();
  };

  return (
    <Grid container direction="column" sx={{ alignItems: "center" }}>
      <Grid
        item
        sx={{ display: "flex", alignItems: "center", width: "100%", mt: 4 }}
      >
        <Autocomplete
          multiple
          limitTags={5}
          id="text-search-terms"
          options={[]}
          value={input}
          freeSolo
          renderTags={(value: readonly string[], getTagProps) =>
            value.map((option: string, index: number) => {
              const { key, ...tagProps } = getTagProps({ index });
              return (
                <Chip
                  variant="outlined"
                  label={option}
                  key={key}
                  {...tagProps}
                />
              );
            })
          }
          sx={{ minWidth: 400 }}
          // There doesn't seem to be a better way (than disabled/error on TextField and length condition onChange) to limit the total number of inputs without enabling the select, which looks bad (https://stackoverflow.com/questions/65101329/how-can-i-limit-the-maximum-number-of-options-that-can-be-selected-in-a-material)
          renderInput={(params) => (
            <TextField
              {...params}
              label="Enter up to five search terms"
              size="small"
              disabled={input.length >= 5}
              error={input.length >= 5}
            />
          )}
          onChange={(event: any, newValue: string[] | null) => {
            if (newValue && newValue.length <= 5) {
              setInput(newValue);
            }
          }}
        />
        <Button
          variant="outlined"
          sx={{ ml: 2 }}
          onClick={handleClick}
          disabled={input.length === 0 ? true : false}
        >
          Go
        </Button>
      </Grid>
      {input.length > 0 && (
        <Grid item sx={{ mt: 2 }}>
          <Typography variant="body2">{input.join(" AND ")}</Typography>
        </Grid>
      )}
    </Grid>
  );
};
